import {
  BRAND_URL,
  REQUEST_10DLC_URL,
  TENDLC_SUSPEND_URL,
  USECASE_SENDER_URL,
  USE_CASE_URL,
} from 'consts/api';
import services from 'services';

class TenDLCServices {
  constructor() {
    //! Suspend
    this.suspend = {
      getListSuspend({ userId }) {
        return services.get(`${TENDLC_SUSPEND_URL}/list/${userId}`);
      },

      suspend(
        body = {
          userId: '',
          vendorIds: [],
        }
      ) {
        return services.post(`${TENDLC_SUSPEND_URL}/suspend`, body);
      },

      unSuspend(
        body = {
          userId: '',
          vendorIds: [],
        }
      ) {
        return services.delete(`${TENDLC_SUSPEND_URL}/unsuspend`, { data: body });
      },
    };

    //! Brand
    this.brand = {
      getListBrand(
        filters = {
          offset: 0,
          limit: 9999,
        }
      ) {
        return services.post(`${BRAND_URL}/list`, filters);
      },

      getDetailBrand(idBrand) {
        return services.get(`${BRAND_URL}/${idBrand}`);
      },

      registerBrand(idBrand, vendorIds) {
        return services.post(`${BRAND_URL}/${idBrand}/register`, vendorIds);
      },

      cancelRegistration(idBrand, vendorIds) {
        return services.post(
          `${REQUEST_10DLC_URL}/brand/${idBrand}/cancel-request-registration`,
          vendorIds
        );
      },

      resetRegistrationStatus({ brandId, vendorId, vendorBrandId }) {
        return services.put(
          `${BRAND_URL}/resetRegistrationStatus?brandId=${brandId}&vendorId=${vendorId}&vendorBrandId=${vendorBrandId}`
        );
      },
    };

    //! Use case
    this.useCase = {
      getAllUseCaseOfBrand(
        brandId,
        filters = {
          offset: 0,
          limit: 9999,
        }
      ) {
        return services.post(`${USE_CASE_URL}/list`, { ...filters, brandId });
      },

      getUseCaseById(idUseCase) {
        return services.get(`${USE_CASE_URL}/${idUseCase}`);
      },

      createUseCaseOfBrand(idBrand, body = {}) {
        return services.post(`${USE_CASE_URL}?brandId=${idBrand}`, body);
      },

      //* when registering failed or still not registering
      updateUseCaseFail(idUseCase, body = {}) {
        return services.put(`${USE_CASE_URL}/${idUseCase}`, body);
      },

      registerUsecaseToVendor(idUseCase, vendorIds) {
        return services.post(`${USE_CASE_URL}/${idUseCase}/register`, vendorIds);
      },

      getVendorOfUseCaseOfUser(idUseCase, vendorId, filters = { offset: 0, limit: 9999 }) {
        return services.post(`${USE_CASE_URL}/${idUseCase}/usecase-vendor/list`, {
          ...filters,
          vendorId,
        });
      },

      getPhoneNumberLinkStatusOfUsecaseOfUser(
        usecaseId,
        vendorUsecaseId,
        filters = {
          offset: 0,
          limit: 9999,
        }
      ) {
        return services.post(`${USE_CASE_URL}/phone-number/status`, {
          ...filters,
          usecaseId,
          vendorUsecaseId,
        });
      },

      deactivateUseCase(idUsecase, vendorId) {
        return services.put(`${USE_CASE_URL}/${idUsecase}/deactivate?vendorId=${vendorId}`);
      },

      completeDeactivate(idUsecase, vendorId) {
        return services.put(
          `${USE_CASE_URL}/${idUsecase}/complete-deactivate?vendorId=${vendorId}`
        );
      },

      cancelRegistration(idUseCase, vendorIds) {
        return services.post(
          `${REQUEST_10DLC_URL}/usecase/${idUseCase}/cancel-request-registration`,
          vendorIds
        );
      },

      updateSenderIds(idUsecase, body) {
        return services.put(`${USECASE_SENDER_URL}/${idUsecase}/senderIds`, body);
      },

      createSenderIds(idUsecase, body) {
        return services.post(`/api/v1/usecase/${idUsecase}/senderIds`, body);
      },

      resetRegistrationStatus({ usecaseId, vendorId, vendorUsecaseId }) {
        return services.put(
          `${USE_CASE_URL}/resetRegistrationStatus?usecaseId=${usecaseId}&vendorId=${vendorId}&vendorUsecaseId=${vendorUsecaseId}`
        );
      },
    };
  }
}

export default new TenDLCServices();
